import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'

import { PinPurpose } from '@flowwai-frontend/bps-officer-web/graphql'
import {
   useSendOtpForUserPin,
   useVerifyOtpForSigningPin
} from '@flowwai-frontend/shared-web/iam/data-access'
import { UserPINUpdateMode } from '@flowwai-frontend/shared-web/iam/ui'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { EMPTY_STRING } from '@flowwai-frontend/shared/constants'
import { UserModel } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import UserPINOTPSubmission from '../../components/UserPINOTPSubmission/UserPINOTPSubmission'
import { useErrorHandler } from './useErrorHandler'

interface Props {
   userDetails: UserModel
   mode: UserPINUpdateMode
   onOtpSubmissionSuccess: () => void

   containerClassName?: string
}

const UserPINOTPController = (props: Props): React.ReactElement => {
   const { userDetails, onOtpSubmissionSuccess } = props

   const [otp, setOtp] = useState(EMPTY_STRING)
   const [otpErrorMessage, setOtpErrorMessage] = useState<string | null>(null)

   const sendOtpAPI = useSendOtpForUserPin()
   const verifyOtpAPI = useVerifyOtpForSigningPin()
   const { handleError } = useErrorHandler({
      setErrorMessage: setOtpErrorMessage
   })

   const errorT = useCustomT('common:common.errorMessages')

   const onSendOtp = (): void => {
      sendOtpAPI.triggerAPI({
         reqObj: {
            pinPurpose: PinPurpose.ESign
         }
      })
   }

   useEffect(onSendOtp, [])

   const onSubmitOtp = () => {
      verifyOtpAPI.triggerAPI({
         requestObj: {
            otp,
            pinPurpose: PinPurpose.ESign
         },
         onSuccess: onOtpSubmissionSuccess,
         onFailure: handleError
      })
   }

   const onResendOtp = () => {
      onSendOtp()

      setOtpErrorMessage(null)
      setOtp(EMPTY_STRING)
   }

   return (
      <UserPINOTPSubmission
         mode={props.mode}
         otp={otp}
         otpErrorMessage={otpErrorMessage}
         onChangeOtp={setOtp}
         onSubmitOtp={onSubmitOtp}
         onResendOtp={onResendOtp}
         phoneNumber={userDetails.phoneNumber}
         apiStatus={verifyOtpAPI.apiStatus}
         containerClassName={props.containerClassName}
      />
   )
}

export default observer(UserPINOTPController)
